import axios from 'axios'
import Cookie from 'js-cookie'

axios.defaults.headers.common['Authorization'] = Cookie.get('token')

const http = axios.create({
    //baseURL: 'http://127.0.0.1:3007/api/amh',
    baseURL: 'http://47.100.25.19:3007/api/amh',
    timeout: 10000,   //10秒
})

//请求拦截
http.interceptors.request.use(config=>{
    if (config.responseType == 'blob') {
        config.responseType = 'blob'
        config.headers['Content-Type'] = "application/json;charset=utf-8"
    }
    config.headers['Authorization'] = Cookie.get('token')
    return config
}, function (error) {
    return Promise.reject(error)
})

//响应拦截
http.interceptors.response.use(function (response) {
    return response
}, function (error) {
    return Promise.reject(error)
})

export default http